module.exports = __webpack_public_path__ + "img/49.7448b60c.png";